import {axiosReq} from "../../../common/utils/axios";

export const tryDeleteAppointment = (cancelToken) => {
    return async dispatch => {
        return axiosReq('apiv1/public/sessions/'+cancelToken, "DELETE", {}, {});
    }
}